export const BRAND = {
  name: "The Next Stage",
  producer: "The Next Stage Media Group, LLC",
  producerShort: "The Next Stage Media Group",
  legacyAffiliate: "Use What You Got Publishing",
  founder: "R. Dale Brunet",
  founderTitle: "Founder / Producer",
  city: "Colorado Springs, Colorado",
  email: "info@TheNextStageShow.com",
  phone: "(719) 205-6381",
  phoneTel: "+17192056381",
  website: "www.TheNextStageShow.com",
  websiteUrl: "https://www.TheNextStageShow.com",
  // Legacy affiliate fields — retained so existing "presented by UWYG" mentions
  // on About / Home / Contact remain renderable until those copy blocks are
  // explicitly re-authored. The public-facing producer is now
  // "The Next Stage Media Group, LLC" (see BRAND.producer above).
  parentSite: "UWYGPublishing.com",
  parentSiteUrl: "http://www.UWYGPublishing.com",
  pilots: {
    one: "Pilot Event One — Fall 2026",
    two: "Pilot Event Two — Early 2027",
  },
  // National expansion markets — the inaugural Colorado Springs event is the
  // first of an ongoing series. Sponsors of the pilot become founding partners
  // of a national platform, not a one-off.
  expansionMarkets: [
    "Denver Tech Center",
    "New Orleans",
    "Salt Lake City",
  ],
};

export const ASSETS = {
  heroLogo:
    "https://customer-assets.emergentagent.com/job_f0e0f3d1-c9ec-4750-9cbc-656067fbc606/artifacts/g1mosp5t_The_Next_Stage_3D_Hero_Logo.jpg",
  headerLogo:
    "https://customer-assets.emergentagent.com/job_f0e0f3d1-c9ec-4750-9cbc-656067fbc606/artifacts/79pzkr50_The_Next_Stage_Header_Logo.jpg",
  // The Next Stage Media Group — 3D full-text producer logo (replaces UWYG)
  producerLogo:
    "https://customer-assets.emergentagent.com/job_d9156fde-9b38-4007-9f7a-724884b38bbb/artifacts/0t1uhw7k_TNS_Media_Group_3D_Full_Text_Logo.jpg",
  // 2D flat letterhead lockup — used at the top of the Media Group About page
  producerLetterhead:
    "https://customer-assets.emergentagent.com/job_d9156fde-9b38-4007-9f7a-724884b38bbb/artifacts/9hy8mmys_TNS_Media_Group_2D_Letterhead_Logo.jpg",
  // 3D trophy-only mark (no full text), background removed transparent PNG —
  // works seamlessly on dark navy without a white halo.
  producerMark:
    "https://customer-assets.emergentagent.com/job_d9156fde-9b38-4007-9f7a-724884b38bbb/artifacts/97qooqa8_TNS_Media_Group_3D_Logo-rbg.png",
  // Original JPG version retained for any white-background placement.
  producerMarkSolid:
    "https://customer-assets.emergentagent.com/job_d9156fde-9b38-4007-9f7a-724884b38bbb/artifacts/1cncqtaj_TNS_Media_Group_3D_Logo.jpg",
  // Legacy UWYG assets — retained for any remaining intentional legacy mentions.
  uwygLogo:
    "https://customer-assets.emergentagent.com/job_emergent-stage-show/artifacts/tvkc69um_UWYG_Publishing_Logo_3D_2.jpg",
  uwygIcon:
    "https://customer-assets.emergentagent.com/job_f0e0f3d1-c9ec-4750-9cbc-656067fbc606/artifacts/1qmb3ny6_UWYG_Publishing_Icon.jpg",
  uwygMark:
    "https://customer-assets.emergentagent.com/job_f0e0f3d1-c9ec-4750-9cbc-656067fbc606/artifacts/guvrkud8_UWYG_Publishing_Icon_Thumbnail.jpg",
  founderHeadshot:
    "https://customer-assets.emergentagent.com/job_emergent-stage-show/artifacts/dfqjo0ey_The_Next_Stage_Stage_Preview_4a.jpg",
  homeHeroBg:
    "https://customer-assets.emergentagent.com/job_emergent-stage-show/artifacts/1nppr6wv_The_Next_Stage_Background_Image_2.jpg",
  brandLogoLockup:
    "https://customer-assets.emergentagent.com/job_emergent-stage-show/artifacts/luc0qwp5_The_Next_Stage_Hero_Logo.jpg",
  brandLogoBanner:
    "https://customer-assets.emergentagent.com/job_emergent-stage-show/artifacts/hesrmgtf_The_Next_Stage_Header_Logo.jpg",
  trophyMark:
    "https://customer-assets.emergentagent.com/job_emergent-stage-show/artifacts/2diah78z_Trophy_Logo-rbg.png",
  stagePreview:
    "https://customer-assets.emergentagent.com/job_emergent-stage-show/artifacts/nijclk13_The_Next_Stage_Stage_Preview.jpg",
  entryPreview:
    "https://customer-assets.emergentagent.com/job_emergent-stage-show/artifacts/u7dg0p9j_The_Next_Stage_Entry_Preview.jpg",
};

export const NAV = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Apply", path: "/apply" },
  { label: "Sponsor", path: "/sponsor" },
  { label: "Attend", path: "/attend" },
  { label: "Partners", path: "/partners" },
  { label: "News", path: "/news" },
  { label: "FAQ", path: "/faq" },
  { label: "Media Group", path: "/media-group" },
  { label: "Contact", path: "/contact" },
];

export const PROMISES = {
  contestants:
    "If you are serious about your message, we will give you a serious stage.",
  audiences:
    "You will experience emerging voices with passion, purpose, and the courage to step forward.",
  sponsors:
    "You will be aligned with a platform that supports entrepreneurship, communication, leadership, personal growth, and community.",
};

export const COMMUNITY_PARTNERS = [
  "Pikes Peak SBDC",
  "BBB of Southern Colorado",
  "Chamber & EDC",
  "Exponential Impact",
  "1 Million Cups COS",
];

export const AUDIENCE_TAGS = [
  "Entrepreneurs",
  "Authors",
  "Storytellers",
  "Advocates",
  "Coaches",
  "Community Leaders",
  "Veterans",
  "Educators",
  "Faith-Based Speakers",
  "Nonprofit Leaders",
  "First Responders",
  "Healthcare Professionals",
  "Creators",
  "Civic Voices",
  "Lived-Experience Speakers",
];

export const INQUIRY_TYPES = [
  "Contestant",
  "Sponsor",
  "Vendor",
  "Volunteer",
  "Media",
  "Partnership",
  "General",
];

export const SPONSOR_TIERS = [
  {
    name: "Presenting Sponsor",
    price: "$15,000",
    limit: "One available per show",
    feature: true,
    blurb:
      "Lead the showcase with premium sponsor positioning, top-tier brand visibility, stage recognition, media recap inclusion, VIP access, and \u201CPresented by\u201D alignment where appropriate.",
    cta: "Inquire About Presenting Sponsorship",
    formValue: "Presenting Sponsor — $15,000",
  },
  {
    name: "Gold Sponsor",
    price: "$7,500",
    blurb:
      "Align your organization with The Next Stage as a major event sponsor supporting production quality, contestant experience, audience engagement, and community visibility.",
    cta: "Inquire About Gold Sponsorship",
    formValue: "Gold Sponsor — $7,500",
  },
  {
    name: "Silver Sponsor",
    price: "$5,000",
    blurb:
      "Support The Next Stage as a key sponsor helping create a professional platform for emerging speakers, entrepreneurs, authors, advocates, and community leaders.",
    cta: "Inquire About Silver Sponsorship",
    formValue: "Silver Sponsor — $5,000",
  },
];

// Sponsor support categories — what dollars actually fund
export const SPONSOR_SUPPORTS = [
  "Venue rental and event operations",
  "Stage, lighting, sound, and A/V engineering",
  "Photography, video, and professional recap content",
  "Awards, trophies, and recognition elements",
  "Marketing, public relations, and community outreach",
  "Speaker support, contestant experience, and post-event visibility",
  "VIP hospitality and audience experience",
  "Insurance, administration, and production logistics",
  "Accessibility, signage, printed programs, and event materials",
];

// Sponsor benefits — used on the Benefits Overview grid
export const SPONSOR_BENEFITS = [
  "Website sponsor recognition",
  "Premium logo placement",
  "Event signage",
  "Stage acknowledgment",
  "Printed or digital program placement",
  "Sponsor table or display opportunity",
  "VIP tickets or reserved seating",
  "General admission tickets",
  "Social media recognition",
  "Email campaign recognition",
  "Post-event recap mention",
  "Event photography access where appropriate",
  "Approved sponsor relationship language",
  "Audience engagement opportunities where appropriate",
  "Invitation to future sponsor previews",
  "Founding sponsor recognition, where applicable",
];

// Sponsor inquiry form — interest level options
export const SPONSOR_INTEREST_OPTIONS = [
  "Presenting Sponsor — $15,000",
  "Gold Sponsor — $7,500",
  "Silver Sponsor — $5,000",
  "In-Kind Sponsorship",
  "Media / Production Partnership",
  "Venue / Hospitality Partnership",
  "Award / Recognition Partnership",
  "Vendor / Exhibitor Inquiry",
  "Community Partnership",
  "Not Sure Yet — Let\u2019s Discuss",
];
